import { render } from "./FinalStep.vue?vue&type=template&id=2e947180&scoped=true"
import script from "./FinalStep.vue?vue&type=script&lang=js"
export * from "./FinalStep.vue?vue&type=script&lang=js"

import "./FinalStep.vue?vue&type=style&index=0&id=2e947180&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e947180"]])

export default __exports__